export default __webpack_public_path__ + "images/e4ab19f5acfbad74eda180c9950116e2-thanksgiving_small.webp";